export var toArray = function (value) { return Array.isArray(value) ? value : [value]; };
//# sourceMappingURL=toArray.js.map


//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-apps-saas/~/@ultimate/ngxerrors/src/utils/toArray.js
// module id = ../../../../@ultimate/ngxerrors/src/utils/toArray.js
// module chunks = 4